import * as types from '../../actions/actiontypes';
import initialState from '../initialstate'


export default function userSearchReducer(state = initialState.userSearchResults, action) {
	switch (action.type) {
		case types.GET_USER_SEARCH: {
			return action.response == undefined ? null : action.response;
		}
		default:
			return state;
	}
}